import template from  './atm_codes_management.html';
import controller from './atm_codes_management.controller';
import './atm_codes_management.scss';

let ATMCodesManagementComponent = {
    restrict: 'E',
    template,
    controller
}

export default ATMCodesManagementComponent;


// WEBPACK FOOTER //
// ./client/app/components/atm_codes_management/atm_codes_management.component.js